import { PileupGetGlobalValueForTag, PileupGetVisibleModifications, PileupGetReducedFeatures, } from './rpcMethods';
export default function PileupRPCMethodsF(pm) {
    pm.addRpcMethod(() => new PileupGetGlobalValueForTag(pm));
    pm.addRpcMethod(() => new PileupGetVisibleModifications(pm));
    pm.addRpcMethod(() => new PileupGetReducedFeatures(pm));
}
